import React, { useEffect, useContext } from "react";

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'

import './App.css';

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

function PartidasPrint({ partidasList, isRemision }) {
  const { getNombreLibro, getNombreLibroProv } = useContext(GlobalContext);

  useEffect(() => {
    console.log("partidas print", partidasList)
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <div>

            { !isRemision ?
              <Container>
                <Table responsive>
                  <thead>
                    <tr>
                      
                      <th>Código ISBN</th>
                      <th>Titulo</th>
                      <th>Autor</th>
                      <th>Cantidad</th>
                      {/*<th>Costo</th>*/}
                      <th>Precio Unitario</th>
                      <th>Descuento</th>
                      <th>Costo</th>
                      <th>Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    { partidasList.map((item, index) => {
                      let libro = getNombreLibro( item.idLibro )
                      
                      return <tr key={ "remmm_" + index }>
                        <td> 
                          { libro.codigoIsbn }
                        </td>
                        <td> 
                          { libro.titulo }
                        </td>
                        <td> 
                          { libro.autor }
                        </td>
                        <td> 
                          { item.cantidad }
                        </td>
                        {/* <td> 
                          { CURRENCY_FORMAT.format( item.costo ) }
                        </td> */}
                        <td> 
                          { CURRENCY_FORMAT.format( item.precio ) }
                        </td>
                        <td> 
                          { item.descuento + ' %' }
                        </td>
                        <td> 
                          { CURRENCY_FORMAT.format( ( item.precio - ( item.precio * (item.descuento / 100) ) ) ) }
                        </td>
                        <td>
                          { CURRENCY_FORMAT.format( ( (item.cantidad * item.precio) - ( (item.cantidad * item.precio) * (item.descuento / 100) ) ) ) }
                        </td>
                      </tr>
                    })}
                  </tbody>
                </Table>
              </Container>
              :
              <Container>
                <Table responsive>
                  <thead>
                    <tr>
                      
                      <th>Solicitados</th>
                      <th>Recibidos</th>
                      <th>Unidad</th>
                      <th>Código de Barras</th>
                      <th>Titulo</th>
                      <th>Precio</th>
                      <th>Descuento</th>
                      <th>Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    { partidasList.map((item, index) => {
                      let libro = getNombreLibroProv( item.ordenDetalle.idLibro )
                      
                      return <tr key={ item.idPartida + "_" + index }>
                        <td> 
                          { item.ordenDetalle.cantidad }
                        </td>
                        <td> 
                          { item.cantidad }
                        </td>
                        <td> 
                          { item.ordenDetalle.unidad }
                        </td>
                        
                        <td> 
                          { libro.codigoIsbn }
                        </td>
                        <td> 
                          { libro.titulo }
                        </td>
                        <td> 
                          { CURRENCY_FORMAT.format(item.precio) }
                        </td>
                        <td> 
                          { item.ordenDetalle.descuento + '%' }
                        </td>
                        <td> 
                          { CURRENCY_FORMAT.format(( item.precio * item.cantidad ) - ( ((item.precio * item.cantidad) * item.ordenDetalle.descuento) / 100 )) }
                        </td>
                      </tr>
                    })}
                  </tbody>
                </Table>
              </Container>
            }
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default PartidasPrint;
